export const TOGGLE_CELL = "TOGGLE_CELL";
export const SHOULD_FLIP = "SHOULD_FLIP";
export const SET_DIMENSIONS = "SET_DIMENSIONS";